import useAnchoredPaginationParams from '@/hooks/requests/useAnchoredPaginationParams';
import { query, EventStatus, type AirdropProjectDTOS } from '@/apis/airdrops';
import { DEFAULT_PAGE_SIZE } from '@/constants/config';

import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

function useAirdropList(status: EventStatus) {
  const [usedData, setUsedData] = useState<any>(undefined);

  const { params, onClickPrev, onClickNext } =
    useAnchoredPaginationParams(usedData);
  const { data, error, isLoading, isError } = useQuery({
    queryKey: ['airdropsList', status, JSON.stringify(params)],
    queryFn: () =>
      query({
        status: status,
        prevId: params.prevId,
        nextId: params.nextId,
        pageSize: DEFAULT_PAGE_SIZE,
      }).then(({ data }) => {
        const hasNextPage =
          data.totalSize > DEFAULT_PAGE_SIZE &&
          params.page * DEFAULT_PAGE_SIZE < data.totalSize;
        const hasPrePage = params.page > 1;
        const nextId = hasNextPage
          ? data.airdropProjectDTOS[data.airdropProjectDTOS.length - 1].id
          : '';
        const prevId = hasPrePage ? data.airdropProjectDTOS[0].id : '';

        console.log(hasNextPage, hasPrePage);
        setUsedData({
          ...data,
          nextId,
          prevId,
        });
        return {
          ...data,
          nextId,
          prevId,
        };
      }),
  });

  return { data, error, isLoading, isError, onClickPrev, onClickNext };
}
export default useAirdropList;
